"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.r = exports.e = exports.w = exports.i = exports.d = void 0;

var _cache = _interopRequireDefault(require("./cache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * List of possible log levels
 * @access private
 * @type {string[]}
 */
var levels = ['DEBUG', 'INFO', 'WARN', 'ERROR'];
/**
 * Is log enabled for a specific level
 * @access private
 * @param {string} level The level to test
 * @returns {boolean}
 */

var isEnabled = function isEnabled(level) {
  return levels.indexOf(level.toUpperCase()) >= levels.indexOf(_cache.default.logLevel.toUpperCase());
};
/**
 * Global Console. (to avoid drop_console...)
 * @access private
 * @type {Console}
 */


var gConsole = global.console;
/**
 * Shorthand for console call
 * @access private
 * @param {string} method A method of the console object
 * @param {string} level The log level
 * @param {*} messages the log content
 */

var logger = function logger(method, level) {
  for (var _len = arguments.length, messages = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    messages[_key - 2] = arguments[_key];
  }

  return isEnabled(level) ? gConsole[method.toLowerCase()].bind(gConsole).apply(void 0, messages) : function () {};
};
/**
 * Use a group to log
 * @access private
 * @param {string} level The log level
 * @param {string} message The group title
 * @param {*} items the log content
 */


var group = function group(level, message) {
  for (var _len2 = arguments.length, items = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    items[_key2 - 2] = arguments[_key2];
  }

  if (items.length > 0) {
    logger.bind(undefined, gConsole.group ? 'group' : level, level)(typeof message === 'string' ? message : '');
    var values = (typeof message !== 'string' ? [message] : []).concat(items);

    if (items.length === 1 && items[0] instanceof Array && typeof items[0].length !== 'undefined') {
      values = items[0]; // eslint-disable-line prefer-destructuring
    }

    values.forEach(function (item) {
      return logger.bind(undefined, level, level)(item);
    });

    if (gConsole.groupEnd) {
      gConsole.groupEnd();
    }
  } else {
    logger.bind(undefined, level, level, message);
  }
};
/**
 * Log debug messages if log level is set to DEBUG.
 * @access protected
 * @see https://developer.mozilla.org/fr/docs/Web/API/Console/log
 */


var d = group.bind(undefined, levels[0]);
/**
 * Log information messages if log level is set to DEBUG or INFO.
 * @access protected
 * @see https://developer.mozilla.org/fr/docs/Web/API/Console/info
 */

exports.d = d;
var i = group.bind(undefined, levels[1]);
/**
 * Log warning messages if log level is set to DEBUG, INFO or WARN.
 * @access protected
 * @see https://developer.mozilla.org/fr/docs/Web/API/Console/warn
 */

exports.i = i;
var w = group.bind(undefined, levels[2]);
/**
 * Log error messages. Errors are always logged.
 * @access protected
 * @see https://developer.mozilla.org/fr/docs/Web/API/Console/error
 */

exports.w = w;
var e = gConsole.error.bind(gConsole);
/**
 * Promise rejection logger to use with catch
 * @access protected
 * @param {string} message
 * @returns {function}
 */

exports.e = e;

var r = function r(message) {
  return function (reason) {
    d(message, reason);
    return Promise.reject(reason || message);
  };
};

exports.r = r;